import React from 'react';

import { useIntl } from '../../../../plugins/publicis-gatsby-plugin-i18n';
import { ArrowIconGoRight, LineBlackBannerHome } from '../../../Atoms/Icons/Icons';
import useMedias from '../../../hooks/useMedias';
import LogoBlack from '../../../assets/images/Colas-Rail-logo-baseline-noir-no-text.png'

import './BannerHome.scss';
import { removeHtmlTag } from '../../../Utils/Utils';

const BannerHome = ({ eventBannerData, imagesArray }) => {
  const intl = useIntl();
  const locale = intl.locale;
  const { getImage } = useMedias();

  const pictoBannerHome = getImage(
    imagesArray,
    eventBannerData?.relationships?.field_image?.drupal_internal__mid
  ).uri?.url;
  return (
    <div className="banner_home_container" style={{ display: !eventBannerData?.field_display ? 'none' : null }}>
      <div className="banner_logo_text">
        <div className="logo_text">
          {
            eventBannerData?.field_display_logo &&
            <>
              <img src={LogoBlack} className="logo-black" alt="Colas Rail" />
              <LineBlackBannerHome customClass="black_line" />
            </>
          }
          {
            pictoBannerHome &&
            <img className="picto" src={pictoBannerHome} alt={eventBannerData?.relationships?.field_image?.field_media_image.alt} />
          }
        </div>
        <div className="text_content" dangerouslySetInnerHTML={{ __html: eventBannerData?.body?.processed }}>
        </div>
      </div>
      <div className="btn_container">
        {
          eventBannerData?.field_lien?.url?.indexOf('.pdf') > 0 ? (
            <a
              href={`${process.env.GATSBY_METADATA_SITE_URL}${locale}/pdf/?file=${eventBannerData?.field_lien?.url}&title=${removeHtmlTag(eventBannerData?.body?.processed || '')}`}
              className="button_banner"
              aria-label={eventBannerData?.field_aria_label || eventBannerData?.field_lien?.title}
            >
              {eventBannerData?.field_lien?.title}
              <ArrowIconGoRight />
            </a>
          ) : (
            <a
              href={eventBannerData?.field_lien?.url}
              className="button_banner"
              aria-label={eventBannerData?.field_aria_label || eventBannerData?.field_lien?.title}
            >
              {eventBannerData?.field_lien?.title}
              <ArrowIconGoRight />
            </a>
          )
        }
      </div>
    </div>
  );
};

export default BannerHome;
